@use "ui/styles/colorsOld";

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  flex-shrink: 0;
  flex-grow: 0;
  background-color: colorsOld.$stoneLightX4;
  border-radius: 3px;

  &.tiny {
    width: 18px;
    height: 18px;
  }

  &.small {
    width: 25px;
    height: 25px;
  }

  &.medium {
    width: 80px;
    height: 80px;
  }

  &.large {
    width: 150px;
    height: 150px;
  }

  img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
}
